import React, { Component } from "react";
import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { ModalItem } from "../../../../Components/Items";

const TIPOS = [
  {
    codigo: 101,
    nombre: "Entrada por compra",
    color: "#10b981",
    esSalida: false,
    descripcion:
      "Ingreso de mercancía al almacén derivado de la recepción de una orden de compra o factura del proveedor.",
    documentos: ["OrdenDeCompra", "Factura", "FacturaSinOrdenDeCompra"],
  },
  {
    codigo: 102,
    nombre: "Reversa entrada",
    color: "#f59e0b",
    esSalida: true,
    descripcion:
      "Anula una entrada por compra previa. Se genera al cancelar una factura o devolución hacia el proveedor.",
    documentos: ["DevolucionCompra", "NotaDeCreditoCompra"],
  },
  {
    codigo: 103,
    nombre: "Entrada por cambio de insumo",
    color: "#14b8a6",
    esSalida: false,
    descripcion:
      "Reingreso a almacén del insumo original devuelto por el cliente al cambiarlo por otro insumo distinto en una venta.",
    documentos: ["Venta"],
  },
  {
    codigo: 201,
    nombre: "Salida a centro de costos",
    color: "#ef4444",
    esSalida: true,
    descripcion:
      "Salida de inventario que se aplica directamente a un centro de costos o gasto interno (no se vende ni se produce).",
    documentos: ["AjusteInventario", "Otro"],
  },
  {
    codigo: 261,
    nombre: "Consumo a producción",
    color: "#8b5cf6",
    esSalida: true,
    descripcion:
      "Salida de insumos que se consumen dentro de un proceso de producción o ensamble.",
    documentos: ["Produccion", "Requisiciones"],
  },
  {
    codigo: 301,
    nombre: "Transferencia entre almacenes",
    color: "#3b82f6",
    esSalida: false,
    descripcion:
      "Movimiento de existencias de un almacén a otro. Genera salida del origen y entrada al destino.",
    documentos: ["TraspasoEntreAlmacenes"],
  },
  {
    codigo: 311,
    nombre: "Cambio ubicación",
    color: "#06b6d4",
    esSalida: false,
    descripcion:
      "Reubicación de existencias dentro del mismo almacén (cambio de zona, anaquel o ubicación lógica).",
    documentos: ["TraspasoEntreAlmacenes"],
  },
  {
    codigo: 601,
    nombre: "Salida por venta",
    color: "#ec4899",
    esSalida: true,
    descripcion:
      "Salida de inventario derivada de una venta a cliente: factura, remisión, punto de venta o tienda en línea.",
    documentos: ["Venta", "PuntoVenta", "WooCommerce", "OnlineStore", "Embarque"],
  },
  {
    codigo: 602,
    nombre: "Salida por cambio de insumo",
    color: "#a855f7",
    esSalida: true,
    descripcion:
      "Salida del insumo de reemplazo entregado al cliente al cambiarlo por el insumo original devuelto en una venta.",
    documentos: ["Venta"],
  },
  {
    codigo: 651,
    nombre: "Salida devolución",
    color: "#f97316",
    esSalida: false,
    descripcion:
      "Reingreso de mercancía al almacén tras una devolución del cliente o nota de crédito.",
    documentos: ["Devolucion", "NotaDeCreditoVenta"],
  },
  {
    codigo: 701,
    nombre: "Ajuste positivo inventario",
    color: "#22c55e",
    esSalida: false,
    descripcion:
      "Aumento manual del inventario por conteo, regularización o ingreso administrativo (sin documento comercial).",
    documentos: [
      "AjusteInventario",
      "RegularizarInventario",
      "Conteo",
      "OrdenAgregarInventario",
    ],
  },
  {
    codigo: 702,
    nombre: "Ajuste negativo inventario",
    color: "#dc2626",
    esSalida: true,
    descripcion:
      "Disminución manual del inventario por conteo, mermas, daños o regularización contable.",
    documentos: ["AjusteInventario", "RegularizarInventario", "Conteo"],
  },
];

class ModalTiposMovimiento extends Component {
  render() {
    return (
      <ModalItem
        title={
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: 28,
                height: 28,
                borderRadius: 8,
                background: "#00BFD615",
                color: "#00BFD6",
              }}
            >
              <InfoCircleOutlined />
            </span>
            <span style={{ fontSize: 15, fontWeight: 600 }}>
              Catálogo de tipos de movimiento
            </span>
          </div>
        }
        visible={this.props.visible}
        onCancel={this.props.onCancel}
        spinning={false}
        paddingTop
        width={780}
        footer={null}
      >
        <div
          style={{
            fontSize: 12,
            color: "#64748b",
            marginBottom: 14,
            lineHeight: 1.5,
          }}
        >
          Cada movimiento de inventario se clasifica con un código que indica
          el motivo y el sentido (entrada o salida). A continuación se describe
          cada tipo y los documentos que normalmente lo originan.
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {TIPOS.map((t) => (
            <div
              key={t.codigo}
              style={{
                display: "flex",
                gap: 12,
                padding: "12px 14px",
                background: "white",
                border: "1px solid #e2e8f0",
                borderRadius: 8,
                borderLeft: `4px solid ${t.color}`,
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 4,
                  minWidth: 70,
                }}
              >
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "4px 10px",
                    borderRadius: 6,
                    background: t.color,
                    color: "white",
                    fontWeight: 700,
                    fontSize: 13,
                    fontFamily:
                      "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
                  }}
                >
                  {t.codigo}
                </span>
                {t.esSalida ? (
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 3,
                      padding: "1px 7px",
                      borderRadius: 999,
                      background: "#fee2e2",
                      color: "#b91c1c",
                      fontWeight: 600,
                      fontSize: 10,
                      border: "1px solid #fecaca",
                    }}
                  >
                    <ArrowUpOutlined style={{ fontSize: 9 }} />
                    Salida
                  </span>
                ) : (
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 3,
                      padding: "1px 7px",
                      borderRadius: 999,
                      background: "#dcfce7",
                      color: "#15803d",
                      fontWeight: 600,
                      fontSize: 10,
                      border: "1px solid #bbf7d0",
                    }}
                  >
                    <ArrowDownOutlined style={{ fontSize: 9 }} />
                    Entrada
                  </span>
                )}
              </div>

              <div style={{ flex: 1, minWidth: 0 }}>
                <div
                  style={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: "#0f172a",
                    marginBottom: 3,
                  }}
                >
                  {t.nombre}
                </div>
                <div
                  style={{
                    fontSize: 12,
                    color: "#475569",
                    lineHeight: 1.5,
                    marginBottom: 6,
                  }}
                >
                  {t.descripcion}
                </div>
                {t.documentos && t.documentos.length > 0 && (
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 4,
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 10,
                        color: "#94a3b8",
                        textTransform: "uppercase",
                        letterSpacing: 0.4,
                        fontWeight: 600,
                        marginRight: 4,
                      }}
                    >
                      Documentos:
                    </span>
                    {t.documentos.map((d) => (
                      <span
                        key={d}
                        style={{
                          fontSize: 10.5,
                          color: "#1e40af",
                          background: "#dbeafe",
                          padding: "1px 7px",
                          borderRadius: 4,
                          fontWeight: 600,
                        }}
                      >
                        {d}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </ModalItem>
    );
  }
}

export default ModalTiposMovimiento;
